import { Model } from '@/models/Model';
export class GoalPlannerTemplate extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'GoalPlannerTemplate';
        this.$endpoint = '/goal-planner-templates';
        this.$fillable = ['title', 'type'];
    }
    duplicate(id) {
        this.$endpoint = '/goal-planner-templates/' + id + '/duplicate';
        return this.request('get', this.$endpoint, {});
    }
    getIsWeekTemplate() {
        return this.type === 'week';
    }
}
